module.exports = __webpack_public_path__ + "234a5d05b947457183b44de5cfc89eb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/si-sprite.svg
// module id = 120
// module chunks = 0